<template>
  <section>
    <div class="standardtem2">
      <span>
        <span v-if="obj.ext_file_url">
          <a :href="linkStr" :download="obj.article_name">下载</a>
        </span>
        <com-control-bar
          :list="list1"
          @control="handleControl"
          @status1="handleStatus11"
          @status0="handleStatus10"
        />

      </span>
      <span class="standardtem2-btn2">
        <com-control-bar
          :list="list2"
          :obj="obj"
          @control="handleControl"
          @status1="handleStatus21"
          @status0="handleStatus20"
        />
      </span>
    </div>
  </section>
</template>

<script>
import comControlBar from '@/components/comControlBar'
export default {
  name: 'ComDtoData2',
  components: { comControlBar },
  props: {
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    list1: {
      type: Array,
      default: () => {
        return []
      }
    },
    list2: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {

    }
  },
  computed: {
    linkStr() {
      return `${process.env.VUE_APP_BASE_API}api/download_pdf?url=${decodeURIComponent(
        this.obj.ext_file_url
      )}&wenku_id=${this.obj.id}`
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    handleControl(v) {
      this.$emit('control', v)
    },
    handleStatus11(v) {
      this.$emit('status11', v)
    },
    handleStatus10(v) {
      this.$emit('status10', v)
    },
    handleStatus21(v) {
      this.$emit('status21', v)
    },
    handleStatus20(v) {
      this.$emit('status20', v)
    }
  }
}
</script>

<style scoped lang="scss">
.standardtem2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  > span {
    @include fun-border(0,"top");
    display: flex;
    align-items: center;
    cursor: pointer;
    height: 100%;
    padding-top: 5px;
    &:nth-child(1) {
      flex: 1;
        display: flex;
        align-items: center;
        height: 50px;

      > span {

        &:nth-child(1) {
          margin-right: 46px;
          > a {
            display: block;
            width: 91px;
            height: 29px;
            padding-top: 5px;
            text-align: center;
            border-radius: 6px;
            font-family: "AdobeHeitiStd-Regular";
            @include fun-design(2)
          }
        }
        &:nth-child(2) {
          padding-left: 55px;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.standardtem2-btn2 /deep/ .el-button--text {
  color: #888;
}
</style>
